import Vue from 'vue' // 引入vue

const Bus = new Vue() // 创建实例

export default Bus // 导出